export default {"src":"/_next/static/media/Coronary Artery Disease.9c61f17b.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};